import { z } from "zod";
export const trimmedString = (opts) => {
    const base = z.string((opts === null || opts === void 0 ? void 0 : opts.emptyMessage) ? { invalid_type_error: opts.emptyMessage } : undefined);
    return base.trim();
};
